import script from "./MessageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDetail.vue?vue&type=script&setup=true&lang=js"

import "./MessageDetail.vue?vue&type=style&index=0&id=651fa474&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651fa474"]])

export default __exports__